<template>
  <div>
    <card center :visible.sync="modals.custom">
      <!-- <fg-input label="網域"
                type="text"
                name="domain"
                data-vv-as="網域"
                v-model="form.domain"   
                :error="getError('domain')"
                required>
      </fg-input> -->
      <fg-input label="商店名稱"
                type="text"
                name="name"
                data-vv-as="商店名稱"
                v-model="form.name"
                v-validate="'required'"    
                :error="getError('name')"
                required />
      <div class="form-group">
        <label class=''>語言 *</label>
        <div class='col-md-7 col-12 row main'>
          <el-select class="select-default" data-vv-as="語言" placeholder="請選擇" name="languageCode" v-model="form.languageCode" :error="getError('languageCode')" v-validate="'required'" >
              <el-option v-for="i in supportedLanguages" class="select-default" :value="i.code" :label="i.displayName" :key="i.code" />
          </el-select>
        </div>
        <div class='text-danger invalid-feedback' style="display:block" v-show="errors.has('languageCode')">{{ errors.first('languageCode') }}</div>
      </div>
      <!-- <div><b>運費</b></div> -->
      <hr style='margin-top:5px;border-width:2px;' />
      <!-- <div class="form-group col-12 row">
        <fg-input label="滿額"
                  type="text"
                  name="shippingFull"
                  labelClasses="col-md-4 col-12"
                  inputClasses="col-md-4 col-12"
                  data-vv-as="滿額"
                  class='row'
                  >
        </fg-input>
        <fg-input label="運費"
                  type="text"
                  name="shippingFee"
                  data-vv-as="運費"
                  labelClasses="col-md-4 col-12"
                  inputClasses="col-md-4 col-12"
                  class='row'
                  >
        </fg-input>
      </div> -->
      <div class="form-group">
        <div class="my-3"><label class='editLabel'>關於我們:</label><button type="button" class="btn btn-fill btn-default btn-sm align-right mx-2" @click="handleEdit('about')">編輯</button></div>
        <div class="my-3"><label class='editLabel'>購物條款:</label><button type="button" class="btn btn-fill btn-default btn-sm align-right mx-2" @click="handleEdit('shoppingTerms')">編輯</button></div>
        <div class="my-3"><label class='editLabel'>隱私權政策:</label><button type="button" class="btn btn-fill btn-default btn-sm align-right mx-2" @click="handleEdit('policy')">編輯</button></div>
      </div>
      <div class="text-right">
        <button type="submit" @click.prevent="validate" class="btn btn-fill btn-info align-right">送出</button>
      </div>
    </card>
    <el-dialog center
      :visible.sync="modals.custom">
      <Editor v-model="content" />
    </el-dialog>
  </div>
</template>
<script>
 /* eslint-disable */ 
  import { DatePicker, Dialog, Table, TableColumn, MessageBox, Select, Option } from 'element-ui'
  import { Checkbox } from 'src/components/index'
  import { Pagination as LPagination } from 'src/components/index'
  import Editor from '../../../components/Editor'
  import lib from '../../../lib'
  import tools from '../../../tools'

  export default {
    components: {
      [DatePicker.name]: DatePicker,
      [Select.name]: Select,
      [Option.name]: Option,
      [Dialog.name]: Dialog,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Checkbox.name]: Checkbox,
      LPagination,
      Editor
    },
    data() {
      return {
        pagination: {
          perPage: 10,
          currentPage: 1,
          total: 0
        },
        form: {
          id: 1,
          name: '',
          languageCode: '',
          about: '',
          shoppingTerms:'',  
          policy: ''
        },
        supportedLanguages: [],
        content:'',
        modals: {
          custom: false
        }
      }
    },
    async mounted() {
      await this.getData()
    },
    watch: {
      'modals.custom': function(val) {
        val || this.saveEditor()
      }
    },
    computed: {
    },
    methods: {
      getError(fieldName) {
        return this.errors.first(fieldName)
      },
      validate() {
        var _this = this
        this.$validator.validateAll().then(isValid => {
          if (!isValid) return
          _this.update()
        })
      },
      openModal(name) {
        this.modals[name] = true
      },
      closeModal(name) {
        this.modals[name] = false
      },
      handleEdit(prop) {
        this.target = prop
        this.content = this.form[this.target]
        this.openModal('custom')
      },
      saveEditor() {
        this.form[this.target] = this.content
        this.closeModal('custom')
      },
      async handleIndexChange(page) {
        await this.getData()
      },
      async getData() {
        // this.query.offset = (this.pagination.currentPage - 1) * this.pagination.perPage
        // this.query.limit = this.pagination.perPage
        var data = await lib.getStore(this.form.id)
        if (data.status == 0) {
          var result = data.result
          var store = result.store
          this.form.name = store.name
          this.form.languageCode = store.languageCode
          this.form.about = store.about
          this.form.shoppingTerms = store.shoppingTerms
          this.form.policy = store.policy  
        }

        data = await lib.getSupportedLanguages()
        if (data.status == 0) {
          var result = data.result
          this.supportedLanguages = result.languages
        }
      },
      async update() {
        var data = await lib.updateStore(this.form.id, this.form)
        if (data.status == 0) {
          await this.getData()
          this.closeModal('custom')
          this.$swal('更新成功', '', 'success')
        } else {
          this.$swal('更新失敗', '', 'error')
        }
      }
    }
  }
</script>


<style>
.toolsBar {
  justify-content: space-between;
  display: flex;
}

.leftTools {
  display: flex;
}


.leftTools > * {
  padding-right: 10px;
}

.editLabel {
  padding-right: 5px;
}
</style>
